import { call, put } from 'redux-saga/effects';
import { Messages } from '../../../codegen/Localize';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ChangeContentTagsAction } from '../../../ts/services/ChangeContentTagsAction';
import { requestFailed } from '../../actions/RequestFailedAction';
import { requestSpaceContents } from '../../actions/spaces/RequestSpaceContentsActions';
import { SetTagsAction } from '../../actions/spaces/SetTagsActions';
import { ServiceLocator } from '../../ServiceLocator';
import { reloadSpaceIfUpdatingCurrentSpace } from './content/RefreshContentSagas';
import { replaceDatasourceIdWithConnectionIdForMixedContent } from './SpacesSagaHelpers';

export function* handleSetTags(action: SetTagsAction) {
  try {
    //Hack to mitigate Datasource API expecting DataConnectionId
    let mutatableContentCopy: IContentInfo[] = [];
    mutatableContentCopy = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, action.content);
    //endHack

    yield call(changeContentTags, mutatableContentCopy);

    // reload the space if we changed its tags so that opening the tags dialog again will have the updated tags info
    const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, action.content);
    if (!maybeReloaded) {
      yield put(requestSpaceContents());
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function changeContentTags(contentCollection: IContentInfo[]): ng.IPromise<IResult> {
  const context = ServiceLocator.getAngularActionContext();
  return ServiceLocator.get<ChangeContentTagsAction>('ChangeContentTagsAction').showChangeTagsForMixedContentDialog(contentCollection, context);
}
